<template>
  <div>
    <v-data-table
      id="adversities-table"
      :headers="headers"
      :items="adversities"
    >
      <template #[`item.view`]="{ item }">
        <v-icon
          style="cursor: pointer"
          class="mr-2"
          @click="_ => viewParty(item)"
        >
          preview
        </v-icon>
      </template>
    </v-data-table>

    <v-radio-group
      v-model="adversityRecognized"
      row
    >
      <v-radio
        key="adversityNotRecognized"
        label="No Adversity"
        :value="false"
      />
      <v-radio
        key="adversityRecognized"
        label="Adversity Exists"
        :value="true"
      />
    </v-radio-group>

    <template v-if="adversityRecognized === true">
      <p>Do you want to ignore adversity and proceed?</p>

      <v-radio-group
        v-model="forcePartyCreation"
        row
      >
        <v-radio
          key="forcePartyCreation"
          label="Yes"
          :value="true"
        />
        <v-radio
          key="doNotForcePartyCreation"
          label="No"
          :value="false"
        />
      </v-radio-group>

      <template v-if="forcePartyCreation === true">
        <p>Provide a short justification for ignoring adversity:</p>

        <v-text-field
          v-model="forceCreationComment"
        />
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PartyAdversities',

  props: {
    adversities: {
      default: _ => ([]),
      type: Array,
    },

    update: {
      default: _ => {},
      type: Function,
    },
  },

  data () {
    return {
      adversityRecognized: null,
      forceCreationComment: null,
      forcePartyCreation: null,
      headers: [
        { text: 'First name', value: 'first_name' },
        { text: 'Middle name', value: 'middle_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'Date of birth', value: 'dob' },
        { text: 'A#', value: 'a_number' },
        { text: 'SSN', value: 'ssn' },
        { text: 'Adverse To (Party Id)', value: 'party_id' },
        { sortable: false, text: 'View', value: 'view' },
      ],
    }
  },

  updated () {
    this.update && this.update({
      adversityRecognized: this.adversityRecognized,
      forceCreationComment: this.forceCreationComment,
      forcePartyCreation: this.forcePartyCreation,
    })
  },

  methods: {
    viewParty (party) {
      const route = this.$router.resolve({ name: 'partyEdit', params: { id: party.id } })
      window.open(route.href, '_blank')
    },
  },
}
</script>
